import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4c3c2752"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "impact-container" };
const _hoisted_2 = {
    key: 0,
    class: ""
};
const _hoisted_3 = {
    key: 1,
    class: "impact"
};
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-exclamation-triangle" }, null, -1 /* HOISTED */));
const _hoisted_5 = {
    key: 2,
    class: "word"
};
const _hoisted_6 = {
    key: 3,
    class: "comma"
};
const _hoisted_7 = {
    key: 4,
    class: "word"
};
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentVariableImpactSummary',
    props: {
        impactedCampaignCount: {},
        impactedCreativeCount: {},
        size: {}
    },
    setup(__props) {
        const props = __props;
        const impactedCampaignsDescription = computed(() => {
            const { impactedCampaignCount } = props;
            if (impactedCampaignCount === 0) {
                return "";
            }
            if (impactedCampaignCount === 1) {
                return "1 Campaign";
            }
            return `${impactedCampaignCount} Campaigns`;
        });
        const impactedCreativesDescription = computed(() => {
            const { impactedCreativeCount } = props;
            if (impactedCreativeCount === 0) {
                return "";
            }
            if (impactedCreativeCount === 1) {
                return "1 Creative";
            }
            return `${impactedCreativeCount} Creatives`;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.size === 'large')
                    ? (_openBlock(), _createElementBlock("h2", _hoisted_2, "Impact:"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_3, [
                        _hoisted_4,
                        _createTextVNode("Impact")
                    ])),
                (_ctx.impactedCampaignCount)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(impactedCampaignsDescription.value), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                (_ctx.impactedCampaignCount && _ctx.impactedCreativeCount)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, ","))
                    : _createCommentVNode("v-if", true),
                (_ctx.impactedCreativeCount)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(impactedCreativesDescription.value), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
